import { useQuery } from "react-query";
import { GET_FAMILY_MEDICAL_HISTORY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getFamilyMedicalHistory } from "api/customers";

const useGetFamilyMedicalHistory = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_FAMILY_MEDICAL_HISTORY, clientId],
    () => getFamilyMedicalHistory(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    familyMedicalHistory: (data?.data || []) as any[],
    familyMedicalHistoryLoading: isLoading,
    refetchFamilyMedicalHistory: refetch,
    ...rest,
  };
};

export default useGetFamilyMedicalHistory;
